import { render, staticRenderFns } from "./SISAlarm.vue?vue&type=template&id=f172a2e0&scoped=true"
import script from "./SISAlarm.vue?vue&type=script&lang=js"
export * from "./SISAlarm.vue?vue&type=script&lang=js"
import style0 from "./SISAlarm.vue?vue&type=style&index=0&id=f172a2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172a2e0",
  null
  
)

export default component.exports